const TransitRoutes = {
  getTransitService: "/getTransitService",
  deleteTransitService: "/deleteTransitService",
};

export default TransitRoutes;
